module.exports = __webpack_public_path__ + "img/project_manager.d8e68f48.svg";